import { Button } from "@/components/ui/button";
import { MASKABLE_FIELD_MINIMIZED_CLASS } from "@/lib/maskable-field-styles";
import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";

type FieldVisibilityToggleProps = {
  expanded: boolean;
  /** Field is minimized (hidden content); styles the eye like other muted UI. */
  minimized?: boolean;
  onToggle: () => void;
  className?: string;
};

export function FieldVisibilityToggle({
  expanded,
  minimized = false,
  onToggle,
  className,
}: FieldVisibilityToggleProps) {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn(
        "h-6 w-6 shrink-0 ml-0",
        minimized ? MASKABLE_FIELD_MINIMIZED_CLASS : "text-slate-500",
        className,
      )}
      onClick={(event) => {
        // Prevent parent label click behavior from toggling related checkbox/radio inputs.
        event.preventDefault();
        event.stopPropagation();
        onToggle();
      }}
      aria-label={expanded ? t("formField.hide") : t("formField.show")}
      aria-pressed={expanded}
    >
      {expanded ? (
        <Eye className="h-4 w-4" aria-hidden />
      ) : (
        <EyeOff className="h-4 w-4" aria-hidden />
      )}
    </Button>
  );
}
